import React, { useEffect, useState } from "react";
import { useDashboard } from "../context/DashboardContext";
import api from "../lib/api";
import { PageHeader, ScoreBreakdown } from "../components/common/PageParts";
import ActiveTradingPlan from "../components/dashboard/ActiveTradingPlan";
import ConfluenceRing from "../components/dashboard/ConfluenceRing";
import SwingSetupCard from "../components/dashboard/SwingSetupCard";

export default function TradePlanner() {
  const { activeSymbol, interval } = useDashboard();
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => { setLoading(true); api.getAnalysis(activeSymbol, interval).then(setAnalysis).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [activeSymbol, interval]);

  return (
    <div className="ym-fade">
      <PageHeader title="Trade Planner" subtitle={`Persistent 4H swing setup + live technical snapshot for ${activeSymbol}`} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <SwingSetupCard symbol={activeSymbol} />
        <ActiveTradingPlan analysis={analysis} loading={loading} onRecalculate={load} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ConfluenceRing analysis={analysis} />
        <ScoreBreakdown analysis={analysis} />
      </div>
    </div>
  );
}
